import React from 'react';
import { autobind } from 'core-decorators';
import Dropzone from 'react-dropzone';
import { injectIntl } from 'react-intl';
import http from 'src/services/httpService';
import { connect } from 'react-redux';

import LoadingContainer from 'src/componentes/loading-container/index';
import Dialog from 'src/componentes/dialog';
import Button from 'src/componentes/button';
import Confirm from 'src/componentes/message-box/confirm';
import Alert from 'src/componentes/message-box/alert';
import ContentManager from 'src/componentes/content-manager';
import SharepointSelectionModal from 'src/components/integracoes/microsoft/sharepoint/modal-file-tree';
import errorHandler from 'src/utils/error-handler';
import css from 'src/utils/css';
import { TAMANHO_MAX_ANEXO, ENTIDADE_ANEXOS } from 'src/utils/constants';

import ProgressBar from './ProgressBar';
import DropzoneArquivoExibicaoTabela from './arquivo-exibicao-tabela';

const baseClasses = css`
  .paper {
    float: left;
    height: 100px;
    width: 110px;
    padding: 5px;
    margin-right: 15px;
    margin-bottom: 15px;
    text-align: center;
    display: inline-block;
    line-height: 1.2;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    font-size: 12px;
    border-radius: 2px;
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
      rgba(0, 0, 0, 0.117647) 0px 1px 4px;
  }
  .popover {
    width: 250px;
  }
  .drop {
    cursor: pointer;
    border: 2px dashed #e0e0e0;
    margin-bottom: 5px;
  }
  .placeholder {
    color: #6d757d;
    font-size: 16px;
    line-height: 18px;
  }
`;

@autobind
class DropZoneAnexos extends React.Component {
  static defaultProps = {
    disabled: false,
    tipoAnexo: null,
    onlyRead: false,
    showDropzone: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      arquivos:
        this.props.model && this.props.model.value
          ? this.props.model.value
          : [],
      files: [],
      current: 0,
      sendingFile: false,
      sizeSent: 0,
      selectedFile: {},
      allFilesSharepoint: [],
      showSharepointModal: false,
    };
  }

  renderDeleteConfirm(anexo) {
    let numAnexos = this.state.arquivos ? this.state.arquivos.length : 0;
    if (numAnexos == 1 && this.props.anexoObrigatorio) {
      ContentManager.addContent(
        <Alert
          message={this.props.intl.formatMessage({
            id: 'obrigatorioPeloMenosUmAnexo',
          })}
        />
      );
    } else {
      ContentManager.addContent(
        <Confirm
          message={this.props.intl.formatMessage({
            id: 'label.desejaMesmoExcluirEsseRegistro',
          })}
          handleConfirm={this.handleDeleteConfirmClick.bind(this, anexo)}
        />
      );
    }
  }

  handleDeleteConfirmClick(anexo) {
    this.props.onDeleting && this.props.onDeleting(anexo);
    let novaLista = [...this.state.arquivos];
    let index = this.state.arquivos.findIndex((a) => a.id === anexo.id);
    if (index !== -1) {
      novaLista.splice(index, 1);
    }
    this.setState({ arquivos: novaLista });
  }

  obterTamanhoMaximoAnexo() {
    switch (this.props.tipoAnexo) {
      case ENTIDADE_ANEXOS.RISCO_AUDITORIA_AVALIACAO:
        return TAMANHO_MAX_ANEXO.ESTENDIDO;
      default:
        return TAMANHO_MAX_ANEXO.PADRAO;
    }
  }

  handleOnDrop(arquivosNovos) {
    let files = [...this.state.files];

    const tamanhoMaxMb = this.obterTamanhoMaximoAnexo();

    const arquivosValidos = arquivosNovos.filter((file) => {
      if (file.size > tamanhoMaxMb * 1024 * 1024) {
        ContentManager.addContent(
          <Alert
            message={`${file.name}: ${this.props.intl
              .formatMessage({
                id: 'tamanhoLimiteUploadArquivos',
              })
              .replace('{0}', tamanhoMaxMb)}`}
          />
        );
        return false;
      }
      return true;
    });

    if (!arquivosValidos.length) return;

    if (this.props.onlyOneFile) {
      files = [arquivosValidos[arquivosValidos.length - 1]];
      this.setState({ files, arquivos: [] });
    } else {
      arquivosValidos.forEach((file) => {
        files.push(file);
      });
      this.setState({ files });
    }
  }

  handleSair() {
    this.refs.dialog.close();
  }

  handleOpenFileTreeSharePoint = () => {
    this.setState({ showSharepointModal: true });
  };

  // Adicione este novo método:
  handleCloseSharepointModal = () => {
    this.setState({ showSharepointModal: false });
  };

  handleConfirmSharepointFile = (file) => {
    let filesSharepoint = this.state.allFilesSharepoint;

    const newArquivo = {
      nome: file.name,
      responsavelNome:
        (this.props.responsavel && this.props.responsavel.nome) || '-',
      fotoColaborador: this.props.responsavel?.fotoArquivo,
      isNew: true,
      ehArquivoSharepoint: true,
      caminhoArquivo: file.filePath,
      extensao: file.extension,
      webUrl: file.webUrl,
      arquivoId: file.id,
      bibliotecaId: file.libraryId,
      siteId: file.siteId,
      dataInclusao: new Date(),
    };

    filesSharepoint.push(newArquivo);

    this.setState({
      selectedFile: file,
      showSharepointModal: false,
      allFilesSharepoint: filesSharepoint,
    });

    // Se você tiver a função handleChageComponentValue, chame aqui:
    if (this.props.handleChageComponentValue) {
      this.props.handleChageComponentValue('dadosSharePoint', file);
    }
  };

  // Atualize o método onSelectFile:
  onSelectFile = (value) => {
    this.setState({ selectedFile: value });
  };

  handleSalvarClick = () => {
    this.setState({ uploading: true });

    var data = new FormData();
    data.append('tipoAnexo', this.props.tipoAnexo);
    data.append('idReferencia', this.props.idReferencia || null);

    this.setState((prevState) => ({
      arquivos: [...prevState.arquivos, ...prevState.allFilesSharepoint],
    }));

    if (this.props.onlyOneFile && this.state.files.length > 1) {
      data.append('files', this.state.files.slice(-1));
    } else {
      this.state.files.map((file) => {
        data.append('files', file);
      });
    }

    http
      .post('ArquivoSistema/uploadArquivos', data)
      .then((result) => {
        if (this.props.onUploadFiles) {
          // Verifica se ja tinha arquivos no model que foi enviado
          if (this.state.arquivos && this.state.arquivos.length > 0) {
            result.data = result.data.concat(this.state.arquivos);
          }
          this.props.onUploadFiles(result.data);
        }

        this.refs.dialog.close();
        this.props.handleAutomaticSave && this.props.handleAutomaticSave();
      })
      .catch((error) => {
        errorHandler(error);
        this.setState({ uploading: false, files: [] });
      });
  };
  render() {
    let { intl, disabled, disabledDownload, onlyRead, showDropzone, ...other } =
      this.props;

    // Função utilitária para formatar datas no locale do usuário
    function formatDate(date) {
      return intl.formatDate(date, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    }

    const arquivos = [
      ...this.state.arquivos.map((a) => ({
        ...a,
        isNew: false,
        dataInclusao: formatDate(new Date(a.dataInclusao)),
      })),
      ...this.state.files.map((f) => ({
        nome: f.name,
        responsavelNome: this.props.responsavel.nome || '-',
        fotoColaborador: this.props.responsavel.fotoArquivo,
        dataInclusao: formatDate(new Date()),
        isNew: true,
      })),
      ...this.state.allFilesSharepoint.map((fs) => ({
        ...fs,
        dataInclusao: formatDate(new Date(fs.dataInclusao)),
      })),
    ];

    const actions = [
      <div>
        <Button
          key="close-Anexos"
          color="secondary"
          leftIcon="close"
          onClick={this.handleSair.bind(this)}
        >
          {intl.formatMessage({ id: 'label.cancelar' })}
        </Button>

        <Button
          disabled={disabled}
          key="save-Anexos"
          className="ml-2"
          leftIcon="content-save-outline"
          onClick={this.handleSalvarClick.bind(this)}
        >
          {intl.formatMessage({ id: 'label.salvar' })}
        </Button>
      </div>,
    ];

    return (
      <>
        <Dialog
          className="popupOpen"
          {...other}
          ref="dialog"
          title={intl.formatMessage({ id: 'label.anexos' })}
          actions={!onlyRead && actions}
          padContent
          onRequestClose={this.handleSair.bind(this)}
          style={{ minWidth: '44.125rem', maxHeight: 'fit-content' }}
        >
          {this.state.sendingFile && (
            <div className="pb-2">
              <p>{intl.formatMessage({ id: 'labelEnviandoUmMaisArquivos' })}</p>
              <ProgressBar current={this.state.current} total={100} />
            </div>
          )}
          <LoadingContainer
            isLoading={this.state.uploading}
            style={{ height: 'auto' }}
          >
            {showDropzone && !onlyRead && (
              <Dropzone
                disabledClick={disabled}
                disabledDownload={disabledDownload}
                className={baseClasses.drop}
                style={{
                  width: this.props.width ? this.props.width : '100%',
                  height: this.props.height ? this.props.height : '8.125rem',
                  textAlign: 'center',
                  padding: 5,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                multiple={!this.props.onlyOneFile}
                onDrop={this.handleOnDrop}
              >
                <span className={baseClasses.placeholder}>
                  {intl.formatMessage({
                    id: 'label.cliqueOuArrasteOArquivoNestaAreaParaAdicionalo',
                  })}
                </span>
              </Dropzone>
            )}

            {this.props.tipoAnexo != null &&
              (this.props.tipoAnexo === 0 ||
                this.props.tipoAnexo === 3 ||
                this.props.tipoAnexo === 4 ||
                this.props.tipoAnexo === 6) &&
              !onlyRead && (
                <div style={{ paddingBottom: 20, paddingTop: 20 }}>
                  <img
                    style={{ width: 22, marginRight: 5 }}
                    alt="Sharepoint"
                    src="/integracoes/sharepoint.svg"
                  />
                  <a
                    className="primary"
                    style={{ fontWeight: 900 }}
                    onClick={this.handleOpenFileTreeSharePoint}
                  >
                    {intl.formatMessage({
                      id: 'label.anexarArquivosSharepoint',
                    })}
                  </a>
                </div>
              )}

            {arquivos.length === 0 && onlyRead && (
              <div
                style={{
                  textAlign: 'center',
                  color: '#6d757d',
                  padding: '2rem',
                }}
              >
                <p
                  style={{
                    fontSize: '1.2rem',
                  }}
                >
                  {intl.formatMessage({
                    id: 'label.naoHaDadosASeremExibidos',
                  })}
                </p>
              </div>
            )}

            {arquivos.length > 0 && (
              <DropzoneArquivoExibicaoTabela
                arquivos={arquivos}
                disabled={disabled}
                disabledDownload={disabledDownload}
                onlyRead={onlyRead}
                onDeleteFile={(arquivo) => {
                  if (arquivo.isNew) {
                    const novos = [...this.state.files];
                    const novosSharepoint = [...this.state.allFilesSharepoint];

                    const idx = novos.findIndex(
                      (nf) => nf.name === arquivo.nome
                    );
                    const idxSharepoint = novosSharepoint.findIndex(
                      (nf) => nf.nome === arquivo.nome
                    );

                    if (idx !== -1) {
                      novos.splice(idx, 1);
                      this.setState({ files: novos });
                    }
                    if (idxSharepoint !== -1) {
                      novosSharepoint.splice(idx, 1);
                      this.setState({ allFilesSharepoint: novosSharepoint });
                    }
                  } else {
                    this.renderDeleteConfirm(arquivo);
                  }
                }}
              />
            )}
          </LoadingContainer>
        </Dialog>

        {this.state.showSharepointModal && (
          <SharepointSelectionModal
            selectedFile={this.state.selectedFile}
            onSelectFile={this.onSelectFile}
            onConfirm={this.handleConfirmSharepointFile}
            onClose={this.handleCloseSharepointModal}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    responsavel: state.user,
  };
}
export default injectIntl(connect(mapStateToProps)(DropZoneAnexos));
